"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ErrorBoundaryInternal = /** @class */ (function (_super) {
    __extends(ErrorBoundaryInternal, _super);
    function ErrorBoundaryInternal(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            error: undefined,
            errorInfo: undefined
        };
        return _this;
    }
    /**
     * Catch errors that are thrown from rendering, lifecycle methods or constructors of **all child elements**. This
     * calls the provided onError function to let the user handle the implementation. This will also cause the component
     * to re-render causing the fallback function to also get called.
     *
     * @param error - The error that was thrown.
     * @param errorInfo - Info about the error thrown.
     */
    ErrorBoundaryInternal.prototype.componentDidCatch = function (error, errorInfo) {
        this.setState({ error: error, errorInfo: errorInfo });
        this.props.onError(error, errorInfo);
    };
    ErrorBoundaryInternal.prototype.render = function () {
        if (this.state.error !== undefined && this.props.fallback) {
            // You can render any custom fallback UI
            return this.props.fallback(this.state.error, this.state.errorInfo);
        }
        return this.props.children;
    };
    return ErrorBoundaryInternal;
}(React.Component));
/**
 * A wrapper designed to catch errors that are thrown from rendering, lifecycle methods or constructors of
 * **all child elements**. This component provides a way to catch these errors and render an alternate interface via
 * fallback() in the event of an error.
 *
 * You can read more on how this works here: https://reactjs.org/docs/react-component.html#componentdidcatch
 */
var ErrorBoundary = function (props) { return (React.createElement(ErrorBoundaryInternal, __assign({}, props))); };
exports.default = ErrorBoundary;
//# sourceMappingURL=ErrorBoundary.js.map